const MembersManagementIndex = () => import('@/views/Dashboard/MembersManagement/MembersManagementIndex');
const MembersManagementAll = () => import('@/views/Dashboard/MembersManagement/MembersManagementAll/MembersManagementAll');
const MembersManagementShowItem = () => import('@/views/Dashboard/MembersManagement/MembersManagementShowItem');
const MembersManagementCreate = () => import('@/views/Dashboard/MembersManagement/MembersManagementCreate');
const MembersManagementEdit = () => import('@/views/Dashboard/MembersManagement/MembersManagementEdit');

export default {
  path: '/members-management',
  component: MembersManagementIndex,
  children: [
    {
      path: '/',
      name: 'members-management',
      component: MembersManagementAll,
      meta: { preserveTableState: true },
    },
    {
      path: 'show/:id',
      name: 'members-management-show',
      component: MembersManagementShowItem,
    },
    {
      path: 'create',
      name: 'members-management-create',
      component: MembersManagementCreate,
    },
    {
      path: 'edit/:id',
      name: 'members-management-edit',
      component: MembersManagementEdit,
    },
  ],
};
